<template>
  <div class="table-container">
    <div class="table-heading">
      <div class="table-heading__title">
        {{ title }}
        <span class="table-heading__count">{{ totalCount || items.length }}</span>
      </div>
      <div class="table-heading__actions">
        <slot name="table-actions" :selectedItems="internalSelectedItems" />
      </div>
    </div>
    <EasyDataTable
      :headers="headers"
      :items="items"
      :loading="loading"
      v-model:items-selected="internalSelectedItems"
      buttons-pagination
      @click-row="$emit('row-click', $event)"
      table-class-name="custom-table"
    >
      <!-- <template v-for="slot in $slots" #[slot.name]="props">
        <slot :name="slot.name" v-bind="props" />
      </template> -->
      <template v-for="(_, name) in $slots" :key="name" #[name]="slotData">
        <slot :name="name" v-bind="{ ...slotData, item: slotData.item || slotData }" />
      </template>
    </EasyDataTable>
  </div>
</template>

<script>
  import { ref, watch } from 'vue';
  import EasyDataTable from 'vue3-easy-data-table';
  import 'vue3-easy-data-table/dist/style.css';

  export default {
    components: {
      EasyDataTable,
    },

    props: {
      title: {
        type: String,
        required: true,
      },
      headers: {
        type: Array,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      totalCount: {
        type: Number,
        default: null,
      },
      selectedItems: {
        type: Array,
        default: () => [],
      },
    },

    emits: ['row-click', 'update:selectedItems'],

    setup(props, { emit }) {
      const internalSelectedItems = ref([...props.selectedItems]);

      // Watch for external changes
      watch(
        () => props.selectedItems,
        (newVal) => {
          internalSelectedItems.value = [...newVal];
        }
      );

      // Emit changes to parent
      watch(internalSelectedItems, (newVal) => {
        emit('update:selectedItems', newVal);
      });

      return {
        internalSelectedItems,
      };
    },
  };
</script>

<style lang="scss" scoped>
  // All table styling is now handled by the global _tables.scss
  // Only component-specific styles remain here
</style>
